import React, { useEffect, useState } from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { Box } from "@mui/material";
import { getLeadStatuses } from "./dashboard-chart-section.utils";
import { seriesPayload } from "./dashboard-chart-section.constant";
import "./dashboard-chart-section.scss";
import RemoveIcon from "../../../../assets/icons/remove_icon.svg";
import DragIcon from "../../../../assets/icons/drag_icon.svg";

const LeadStatusesChartSection: any = (props: any) => {
  const { metricsData } = props;
  const [leadsByStatus, setLeadsByStatus] = useState<any>([]);

  const LegendItem = (propss: any) => {
    const { color, label } = propss;
    return (
      <Box display="flex" alignItems="center" mb={1}>
        <svg
          width="15"
          height="15"
          viewBox="0 0 9 9"
          fill="none"
          style={{ marginRight: 8 }}
        >
          <circle cx="4.5" cy="4.5" r="4" fill={color} />
        </svg>
        <span>{label}</span>
      </Box>
    );
  };

  useEffect(() => {

    setLeadsByStatus(getLeadStatuses(metricsData?.leadsByStatus) || []);
    // setTimeout(() => {
    // }, 100);
  }, [metricsData]);

  return (
    <div className="dashboard-chart-section">
      <div className="dashboard-chart-section-cards">
        <div className="dashboard-chart-section-cards-chart">
          <div className="pie-chart-wrapper">
            <PieChart
              series={[
                {
                  ...seriesPayload,
                  data: leadsByStatus,
                  sortingValues: "desc",
                  valueFormatter: () => {
                    return ``;
                  },
                },
              ]}
              height={160}
              width={160}
              legend={{
                hidden: true,
                position: {
                  vertical: "middle",
                  horizontal: "right",
                },
                direction: "column",
                itemMarkWidth: 10,
                itemGap: 3,
                markGap: 10,
                labelStyle: {
                  fontSize: 15,
                },
              }}
              margin={{
                bottom: 0,
                left: 0,
                right: 0,
                top: 0,
              }}
            />
          </div>
          <div className="legend-wrapper">
            {leadsByStatus?.map((item: any) => (
              <LegendItem key={item.id} color={item.color} label={item.label} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default LeadStatusesChartSection;
